import React, { useMemo, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./style.scss";
import SolicitacoesCard from "./SolicitacoesCard";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "~components/Form/components/Loader";
import { Spinner } from "@chakra-ui/react";

const SolicitacoesListagem = ({
  solicitacoes,
  loading,
  setLoading,
  skip,
  take,
  setSkip,
  carregando,
  handleAddButton,
}) => {
  const [itemsToShow, setItemsToShow] = useState(5);
  const [hasMore, setHasMore] = useState(true);
  const previousLengthRef = useRef(solicitacoes.length);

  const loadMoreItems = () => {
    setLoading(true);

    const newItemsToShow = itemsToShow + 5;
    const maxItems = fixedSolicitacao.length;

    setItemsToShow(Math.min(newItemsToShow, maxItems));
    setSkip(skip + take);

    if (newItemsToShow >= maxItems) {
      setHasMore(false);
    }

    setLoading(false);
  };

  const fixedSolicitacao = useMemo(() => {
    if ((solicitacoes || []).length > 0) {
      return solicitacoes.map((e) => {
        let status = "Pendente";
        let origem = "Nova Negociação";
        let prefix = "FX";

        switch (e.status) {
          case "Concluido":
          case "Concluído":
            status = "Concluído";
            break;
          case "Rejeitado":
          case "Recusado":
            status = "Recusado";
            break;
        }

        switch (e.origem) {
          case "Renovacao":
            origem = "Renovação";
            break;
          case "Simulador":
            origem = "Simulador";
            break;
        }

        switch (e.tipoCondicaoLabel) {
          case "Condição Especial":
            prefix = "CE";
            break;
          case "Manter no Regra":
            prefix = "MR";
            break;
        }

        let rejected = 0;
        const steps = (e.steps || []).map((c) => {
          let stepStatus = c.status;
          if (rejected == 0) {
            switch (stepStatus) {
              case "Liberado":
                stepStatus = "Concluído";
                break;
              case "Recusado":
                stepStatus = "Recusado";
                break;
              case "Bloqueado":
                stepStatus = "Recusado";
                rejected++;
                break;
              default:
                stepStatus = "Pendente";
                break;
            }
          } else {
            stepStatus = "Recusado";
          }

          c.data = c.dataFormatada;
          c.status = stepStatus;

          return c;
        });

        return {
          ...e,
          title: `${prefix}:${e.codigo} - ${e.tipoCondicaoLabel}`,
          cliente: e.clienteLabel ?? "",
          produtos: e.produtos,
          observacao: e.observacao ?? "NA",
          productGroup: e.grupoProdutoLabel ?? "",
          status: status,
          origem: origem,
          steps: steps,
        };
      });
    }
    return [];
  }, [solicitacoes]);

  useEffect(() => {
    if (solicitacoes.length !== previousLengthRef.current || itemsToShow == 0 || itemsToShow > solicitacoes?.length) {
      const countItemsToShow = solicitacoes.length >= 5 ? 5 : solicitacoes.length;
      setItemsToShow(countItemsToShow);
      setHasMore(true);
      previousLengthRef.current = solicitacoes.length;
    }
  }, [itemsToShow, solicitacoes]);

  return (
    <section className="prices-table-solicitacoes">
      <div className="content container">
        <div className="flex justify-between mb-6">
          {fixedSolicitacao.length > 0 && (
            <p>
              Exibindo <span className="font-bold">{itemsToShow}</span> de {fixedSolicitacao.length}
            </p>
          )}
          {carregando && (
            <p className="flex justify-end items-center gap-2 text-sm">
              <Spinner size={"sm"} />
              Verificando se há atualizações nas solicitações
            </p>
          )}
        </div>
        <InfiniteScroll
          dataLength={itemsToShow}
          next={loadMoreItems}
          hasMore={hasMore}
          loader={loading && <Loader list={true} />}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Fim da lista</b>
            </p>
          }
        >
          {fixedSolicitacao.slice(0, itemsToShow).map((solicitacao, index) => (
            <SolicitacoesCard
              key={solicitacao.id}
              solicitacao={solicitacao}
              {...solicitacao}
              handleAddButton={handleAddButton}
            />
          ))}
        </InfiniteScroll>
      </div>
    </section>
  );
};

SolicitacoesListagem.propTypes = {
  solicitacoes: PropTypes.array,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  skip: PropTypes.number,
  take: PropTypes.number,
  setSkip: PropTypes.func,
  carregando: PropTypes.bool,
  handleAddButton: PropTypes.func,
};

export default SolicitacoesListagem;
